function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnCoinPlusPressed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-710 -440)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "\\uC0AC\\uAC01\\uD615 217",
  width: 32,
  height: 32,
  rx: 16,
  transform: "translate(710 440)",
  style: {
    fill: "#414555"
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 131",
  d: "M718.079 456h14",
  transform: "translate(.921)",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 132",
  d: "M718.079 456h14",
  transform: "rotate(90 725.54 456.46)",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnCoinPlusPressed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fcc2fb58d9f0e330d4ecd148d1fbc954.svg";